import { CreditCard, CheckCircle2 } from 'lucide-react';

const PARTNERS = [
  { type: 'img', src: '/partners/klarna.svg', alt: 'Klarna' },
  { type: 'text', alt: 'Afterpay' },
  { type: 'img', src: '/partners/mercadopago.svg', alt: 'Mercado Pago' },
  { type: 'img', src: '/partners/hotmart.svg', alt: 'Hotmart' },
  { type: 'img', src: '/partners/capitalone.png', alt: 'Capital One' },
];

const CUOTAS = ['6', '12', '18', '24', '36'];

const PaymentPartners = () => (
  <div
    data-testid="payment-partners"
    className="mb-8 rounded-2xl border-2 border-[#80C753]/30 bg-gradient-to-br from-[#80C753]/5 via-white to-[#45A0EE]/5 dark:from-[#80C753]/10 dark:via-[#151B2B] dark:to-[#45A0EE]/10 p-6 sm:p-8"
  >
    <div className="text-center max-w-2xl mx-auto mb-6">
      <div className="inline-flex items-center gap-2 bg-[#80C753]/15 text-[#5a9b36] px-3 py-1 rounded-full text-[11px] font-black uppercase tracking-wider mb-3">
        <CreditCard className="h-3.5 w-3.5" /> Financiamiento disponible
      </div>
      <h3 className="text-2xl sm:text-3xl font-black text-[#1D1D1B] dark:text-white mb-2">
        Paga a tu ritmo — <span className="text-[#80C753]">hasta 36 cuotas</span>
      </h3>
      <p className="text-slate-600 dark:text-slate-300 text-sm">
        Aceptamos pagos en <strong>6, 12, 18, 24 y hasta 36 cuotas</strong> a través de nuestros socios de pago.
      </p>
    </div>

    {/* Cuotas */}
    <div className="flex flex-wrap items-center justify-center gap-2 mb-6">
      {CUOTAS.map((c) => (
        <span
          key={c}
          className="inline-flex items-center gap-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-full px-3.5 py-1.5 text-sm font-bold text-[#1D1D1B] dark:text-white shadow-sm"
        >
          <CheckCircle2 className="h-3.5 w-3.5 text-[#80C753]" /> {c} cuotas
        </span>
      ))}
    </div>

    {/* Logos de socios */}
    <div className="flex flex-wrap items-center justify-center gap-3">
      {PARTNERS.map((p) => (
        <div
          key={p.alt}
          title={p.alt}
          className="bg-white rounded-xl border border-slate-200 h-14 w-32 flex items-center justify-center px-4 shadow-sm"
        >
          {p.type === 'text' ? (
            <span className="font-black text-[15px] tracking-tight">
              <span className="text-black">after</span><span className="text-[#0aa89a]">pay</span>
            </span>
          ) : (
            <img src={p.src} alt={p.alt} className="max-h-7 max-w-full object-contain" loading="lazy" />
          )}
        </div>
      ))}
    </div>

    <p className="text-center text-[11px] text-slate-400 dark:text-slate-500 mt-5">
      La disponibilidad de cuotas y socios puede variar según tu país y método de pago.
    </p>
  </div>
);

export default PaymentPartners;
